export const thirdwebClientId = String(process.env.NEXT_PUBLIC_THIRDWEB_CLIENT_ID)
